import _ from "lodash";
/** External */
import React from "react";
/** Internal */
import { MODE_TEACHER_CREATE } from "Worksheet/modules/WorksheetConstants";
/** Relative */
import SideBarItem from "../SideBarItem";

const ChildOptions = props => {
  const {
    childOption,
    mode,
    errorState,
    toggleRef,
    studentId,
    renderEvaluation,
    isEvaluationApplicable,
    submissionStatus,
    childIndex,
    debouncedUpdateEvaluateScoreMutation,
    debouncedUpdateSectionMutation,
    academicTermId,
    updateScoreElementRating,
    totalMarks,
  } = props;

  const childOptionId = _.get(childOption, "id");

  const showWarningIcon =
    mode == MODE_TEACHER_CREATE
      ? _.get(errorState, childOptionId, false)
      : false;

  return (
    <SideBarItem
      toggleRef={toggleRef}
      mode={mode}
      studentId={studentId}
      renderEvaluation={renderEvaluation}
      isEvaluationApplicable={isEvaluationApplicable}
      submissionStatus={submissionStatus}
      index={childIndex}
      debouncedUpdateEvaluateScoreMutation={
        debouncedUpdateEvaluateScoreMutation
      }
      debouncedUpdateSectionMutation={debouncedUpdateSectionMutation}
      errorState={errorState}
      showWarningIcon={showWarningIcon}
      academicTermId={academicTermId}
      updateScoreElementRating={updateScoreElementRating}
      totalMarks={totalMarks}
      {...childOption}
    />
  );
};

export default ChildOptions;
